import React, { useState, Fragment } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';

const ViewContractMasterList = ({ contractMaster, index }) => {

    const [showViewModel, setShowViewModel] = useState(false);
    const [showEditModel, setShowEditModel] = useState(false);
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const currentUser = useSelector((state) => state.user.currentUser);

    return (
        <Fragment>
            <tr
                key={contractMaster._id}
                className={`${index % 2 !== 0 && 'bg-gray-100'}`}
            >
                <TD>{index + 1}</TD>
                <TD>
                    {contractMaster.effectiveDate
                        ? new Date(contractMaster.effectiveDate).toLocaleDateString("en-GB").replace(/\//g, '-')
                        : ''}
                </TD>
                <TD>
                    {contractMaster.renewalDate
                        ? new Date(contractMaster.renewalDate).toLocaleDateString("en-GB").replace(/\//g, '-')
                        : ''}
                </TD>

                <TD>{contractMaster?.vendor}</TD>
                <TD>{contractMaster?.fleet}</TD>
                <TD>{contractMaster?.hub}</TD>
                <TD>{contractMaster?.repairCost}</TD>
             
                <TD>
                    {checkPermission([permissions.manage_masters], currentUser) ? (
                        <div className="">
                            <button
                                onClick={() => setShowEditModel(true)}
                                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
                            >
                                <FaEdit />
                            </button>
                            <button
                                onClick={() => setShowViewModel(true)}
                                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
                            >
                                <FaEye />
                            </button>
                        </div>
                    ) : (
                        <p>----</p>
                    )}
                </TD>
            </tr>

            {/* {showViewModel && (
                <EditApplicationType
                    data={contractMaster}
                    desable={true}
                    handleClick={() => setShowViewModel(false)}
                />
            )}
            {showEditModel && (
                <EditApplicationType
                    data={contractMaster}
                    handleClick={() => setShowEditModel(false)}
                />
            )} */}

        </Fragment>
    )
}

export default ViewContractMasterList
